import { createTheme, responsiveFontSizes } from "@mui/material/styles";

export const darkTheme = responsiveFontSizes(
  createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: "#0c3759",
        contrastText: "#e5ebf1",
      },
      secondary: {
        main: "#121a21",
        contrastText: "#e5ebf1",
      },
    },
  })
);

export const lightTheme = responsiveFontSizes(
  createTheme({
    palette: {
      mode: "light",
      primary: {
        main: "#0c3759",
        light: "#114f7e",
        dark: "#072236",
        contrastText: "#eff3f6"
      },
      secondary: {
        main: "#dee6ed",
        contrastText: "#090d10",
      },
      divider: "rgba(0,0,0,0.12)"
    },
    components: {
      MuiDivider: {
        styleOverrides: {
          root: ({ ownerState, theme }) => ({
            borderColor: theme.palette.primary[500],
          }),
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          notchedOutline: ({ ownerState, theme }) => ({
            ...(ownerState.disabled && {
              backgroundColor: "black",
              opacity: 0.025,
            })
          }),
        }
      },
    },
  })
);